import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin } from "@phosphor-icons/react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ChatWidget from "../components/ChatWidget";
import FloatingActions from "../components/FloatingActions";
import Seo from "../components/Seo";
import { SUBURBS_SEO, REGIONS } from "../lib/suburbs";

export default function SuburbsIndex() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": "Painters in Melbourne — All Suburbs",
    "description": "Directory of all Melbourne suburbs covered by The Melbourne Painters.",
    "url": "https://themelbournepainters.com.au/painters",
    "hasPart": SUBURBS_SEO.map((s) => ({
      "@type": "Place",
      "name": s.name,
      "address": { "@type": "PostalAddress", "addressLocality": s.name, "postalCode": s.postcode, "addressRegion": "VIC", "addressCountry": "AU" },
      "url": `https://themelbournepainters.com.au/painters/${s.slug}`,
    })),
  };

  return (
    <div className="min-h-screen bg-[#F2F2EF] text-[#111]">
      <Seo
        title="Painters in Melbourne — All 94 Suburbs We Cover | The Melbourne Painters"
        description="Find a premium Melbourne painter near you. 94 suburbs across Inner SE, Bayside, South East Melbourne & the Mornington Peninsula. Free 24-hour quotes."
        keywords="Melbourne painters near me, suburb painters Melbourne, local painters Melbourne, Bayside painters, Mornington Peninsula painters"
        path="/painters"
        jsonLd={jsonLd}
      />
      <Header />

      <section data-testid="suburbs-index" className="pt-32 md:pt-40 pb-12 md:pb-16 px-5 md:px-10 lg:px-16 grain">
        <Link to="/" className="text-xs uppercase tracking-widest text-[#666] hover:text-[#D85C3A]">← Home</Link>
        <h1 className="font-display text-6xl md:text-8xl lg:text-[9rem] uppercase tracking-tighter leading-[0.86] mt-4">
          Where<br />we <span className="text-[#D85C3A]">paint</span>.
        </h1>
        <p className="mt-6 max-w-2xl text-lg">
          {SUBURBS_SEO.length} suburbs across the South-East and Mornington Peninsula. Click a suburb for a local quote and recent projects.
        </p>
      </section>

      {REGIONS.map((region) => {
        const list = SUBURBS_SEO.filter((s) => s.region === region);
        if (list.length === 0) return null;
        return (
          <section key={region} className="py-12 md:py-16 px-5 md:px-10 lg:px-16 border-t-2 border-[#111]">
            <div className="flex items-end justify-between mb-6 flex-wrap gap-3">
              <h2 className="font-display text-3xl md:text-5xl uppercase tracking-tighter leading-[0.92]">{region}</h2>
              <span className="text-xs uppercase tracking-widest text-[#666]">{list.length} suburbs</span>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
              {list.map((s) => (
                <Link
                  to={`/painters/${s.slug}`}
                  key={s.slug}
                  data-testid={`index-suburb-${s.slug}`}
                  className="border-2 border-[#111] p-4 bg-[#F2F2EF] hover:bg-[#D85C3A] hover:text-white transition-colors group flex items-start justify-between gap-2"
                >
                  <div className="min-w-0">
                    <span className="font-display text-lg md:text-xl uppercase tracking-tight block truncate">{s.name}</span>
                    <div className="flex items-center gap-1 text-[10px] uppercase tracking-widest opacity-60 mt-0.5">
                      <MapPin size={10} weight="duotone" /> VIC {s.postcode}
                    </div>
                  </div>
                  <ArrowUpRight size={18} weight="bold" className="opacity-50 group-hover:opacity-100 group-hover:rotate-45 transition-all flex-shrink-0" />
                </Link>
              ))}
            </div>
          </section>
        );
      })}

      <Footer />
      <ChatWidget />
      <FloatingActions />
    </div>
  );
}
